interface ClarityWindow extends Window {
  [key: string]: unknown;
}

export function loadTrackingScripts() {
  if (import.meta.env.VITE_ENVIRONMENT === 'production') {
    (function (c: ClarityWindow, l: Document, a: 'clarity', r: 'script', i: string) {
      interface ClarityFunction {
        (...args: unknown[]): void;
        q?: unknown[][];
      }

      if (!c[a]) {
        const clarityFunc: ClarityFunction = (...args: unknown[]) => {
          (clarityFunc.q = clarityFunc.q || []).push(args);
        };
        c[a] = clarityFunc;
      }

      const t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = 'https://www.clarity.ms/tag/' + i;

      const scripts = l.getElementsByTagName(r);
      const y = scripts.length > 0 ? scripts[0] : null;

      if (y?.parentNode) {
        y.parentNode.insertBefore(t, y);
      }
    })(
      window as unknown as ClarityWindow,
      document,
      'clarity',
      'script',
      'rwy1ocx6ux',
    );

    const cookiebotScript = document.createElement('script') as HTMLScriptElement;
    cookiebotScript.id = 'Cookiebot';
    cookiebotScript.src = 'https://consent.cookiebot.com/uc.js';
    cookiebotScript.setAttribute(
      'data-cbid',
      '54af315e-92fa-4cea-98fa-a504ac30344a',
    );
    cookiebotScript.setAttribute('data-blockingmode', 'auto');
    cookiebotScript.type = 'text/javascript';
    document.head.appendChild(cookiebotScript);
  }
}
